import { createContext, useState, useCallback, useContext } from "react";

export const AlertContext = createContext(null);

export default function AlertProvider({ children }) {
  const [alerts, setAlerts] = useState([]);

  const showAlert = useCallback(({ type = "info", message, duration = 4000 }) => {
    const id = Date.now() + Math.random();
    setAlerts((a) => [...a, { id, type, message }]);
    setTimeout(() => setAlerts((a) => a.filter((x) => x.id !== id)), duration);
  }, []);

  const dismiss = useCallback(
    (id) => setAlerts((a) => a.filter((x) => x.id !== id)),
    []
  );

  return (
    <AlertContext.Provider value={{ alerts, showAlert, dismiss }}>
      {children}
    </AlertContext.Provider>
  );
}

export const useAlert = () => useContext(AlertContext);
